// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__3JRP-","dragIcon":"Choice_dragIcon__1ilkS","left":"Choice_left__1X-vL","input":"Choice_input__4bhys"};